<template>
  <button @click="$emit('action')"
          :disabled="loading || disabled"
          :class="{
      'relative flex items-center text-white bg-primary disabled:bg-gray-400 px-6 text-xs lg:text-md lg:px-9 py-2.5 rounded-full border-primary transition-all hover:bg-accent hover:border-accent' : type === 'primary',
         'relative flex items-center text-white bg-accent disabled:bg-gray-400 px-6 text-xs lg:text-md lg:px-9 py-2.5 rounded-full border-accent transition-all hover:bg-accent_hover hover:border-accent_hover' : type === 'secondary',
      'relative flex items-center text-white bg-primary text-base px-20 py-2.5 rounded-full border-primary transition-all hover:bg-accent hover:border-accent' : type === 'primary-save',
      'relative flex items-center text-white bg-primary text-base px-32 py-2.5 rounded-full border-primary transition-all hover:bg-accent hover:border-accent' : type === 'primary-login',
      'relative flex items-center text-white bg-primary px-3 py-1.5 rounded-full border-primary transition-all hover:bg-accent hover:border-accent text-sm' : type === 'primary-small',
      'relative flex items-center text-primary border border-primary px-6 text-xs lg:text-md lg:px-9 py-2.5 rounded-full hover:bg-accent hover:border-accent hover:text-white transition-all' : type === 'primary-outline',
      'relative flex items-center text-primary border border-primary px-5 py-1.5 rounded-full hover:bg-accent hover:border-accent hover:text-white transition-all' : type === 'primary-outline-small',
      'relative flex items-center text-primary border border-primary px-2 py-0.5 rounded-full hover:bg-accent hover:border-accent hover:text-white transition-all' : type === 'primary-outline-xs',
      'relative hover:underline text-red-500': type === 'primary-text-danger',
      'relative hover:underline text-primary': type === 'primary-text',
      }"
  >
    <template v-if="loading === true">
    <span v-if="type === 'primary' || type === 'primary-save' || type === 'primary-login'"
          class="loading-animation-custom-dark"></span>
      <span v-else-if="type === 'primary-small'" class="loading-animation-custom-dark-small"></span>
      <span v-else-if="type === 'primary-outline'" class="loading-animation-custom-white"></span>
      <span v-else-if="type === 'primary-outline-small'"
            class="loading-animation-custom-white-small"></span>
      <span v-else-if="type === 'primary-text-danger'" class="loading-animation-custom-red"></span>
      <span v-else-if="type === 'primary-text'" class="loading-animation-custom-text-primary"></span>
    </template>
    <slot/>
    <span v-if="tooltip && tooltip.length > 0" class="ml-1">
      <AdvancedTooltip :title="tooltip" theme="blue">
        <IconTooltip/>
      </AdvancedTooltip>
    </span>
  </button>
</template>
<script setup lang="ts">
import {ref} from "vue";
import AdvancedTooltip from "@/components/tooltip/AdvancedTooltip.vue";
import IconTooltip from "@/components/svg_icons/IconTooltip.vue";

const toggleActive = ref(0);

const props = defineProps({
  type: {
    type: String,
    required: false,
    default: 'primary'
  },
  loading: {
    type: Boolean,
    required: false,
    default: false
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false
  },
  tooltip: {
    type: String,
    required: false,
    default: ''
  }
});
const emits = defineEmits(["action"])
</script>
